webpackJsonp([1],{

/***/ "+Gxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__("/Put");
function injectStyle (ssrContext) {
  __webpack_require__("AcTI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/Put":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__table__ = __webpack_require__("fnDg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */]);

/***/ }),

/***/ "/oiM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Features',
  data: function data() {
    return {
      msg: ''
    };
  }
});

/***/ }),

/***/ "0w6L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "17MB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"luxbar-fixed",attrs:{"id":"luxbar"}},[_c('input',{staticClass:"luxbar-checkbox",attrs:{"type":"checkbox","id":"luxbar-checkbox"}}),_vm._v(" "),_c('div',{staticClass:"luxbar-menu luxbar-menu-right luxbar-menu-dark container"},[_c('ul',{staticClass:"luxbar-navigation"},[_c('li',{staticClass:"luxbar-header"},[_c('a',{staticClass:"luxbar-brand",attrs:{"href":"/"}},[_c('img',{staticClass:"hackdagio-main-logo",attrs:{"src":"static/img/logos/hackdagio.svg","alt":"HACKDAGIO"}})]),_vm._v(" "),_c('label',{staticClass:"luxbar-hamburger luxbar-hamburger-doublespin",attrs:{"id":"luxbar-hamburger","for":"luxbar-checkbox"}},[_c('span')])]),_vm._v(" "),_c('li',{staticClass:"luxbar-item"},[_c('a',{attrs:{"href":"https://hackdagio.blog","target":"_blank"}},[_vm._v("blog")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2vPH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "340w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Why_vue__ = __webpack_require__("Ft9h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a1655a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Why_vue__ = __webpack_require__("FAPV");
function injectStyle (ssrContext) {
  __webpack_require__("V6qR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a1655a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Why_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a1655a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Why_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3tuG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"container-fluid"},[_c('div',{staticClass:"footer-list row"},[_c('div',{staticClass:"footer-list-item col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2"}),_vm._v(" "),_c('div',{staticClass:"footer-list-item col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"}),_vm._v(" "),_c('div',{staticClass:"footer-list-item social-list col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6"},[_c('img',{staticClass:"hackdagio-main-logo",staticStyle:{"height":"12px","margin-bottom":"12px"},attrs:{"src":"static/img/logos/hackdagio.svg","alt":"HACKDAGIO"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('ul',[_c('li',[_c('a',{staticClass:"stalk-icon",attrs:{"href":"https://twitter.com/hackdagio","target":"_blank"}},[_c('svg',{staticClass:"social-icon social-twitter",attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","xmlns:a":"http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/","x":"0px","y":"0px","viewBox":"0 -0.001 30 21","overflow":"visible","enable-background":"new 0 -0.001 30 21","xml:space":"preserve"}},[_c('defs'),_vm._v(" "),_c('path',{attrs:{"d":"M30,9.542c-1.057,0.179-2.586-0.007-3.398-0.347c1.687-0.139,2.828-0.905,3.269-1.946\n                  c-0.606,0.374-2.496,0.782-3.537,0.394c-0.051-0.246-0.106-0.479-0.164-0.69c-0.793-2.916-3.512-5.268-6.356-4.984\n                  c0.227-0.093,0.461-0.178,0.694-0.257c0.312-0.112,2.152-0.414,1.863-1.062c-0.246-0.571-2.492,0.432-2.916,0.563\n                  c0.56-0.21,1.481-0.57,1.582-1.214c-0.854,0.118-1.695,0.523-2.345,1.112c0.232-0.253,0.41-0.56,0.447-0.891\n                  c-2.281,1.46-3.615,4.401-4.694,7.256c-0.847-0.822-1.6-1.469-2.272-1.831c-1.891-1.012-4.15-2.07-7.697-3.389\n                  C4.367,3.43,5.056,4.995,7.039,6.032C6.611,5.974,5.824,6.103,5.195,6.254c0.257,1.348,1.093,2.455,3.359,2.991\n                  C7.52,9.311,6.984,9.55,6.5,10.058c0.471,0.936,1.624,2.037,3.691,1.812c-2.302,0.992-0.938,2.832,0.936,2.561\n                C7.932,17.734,2.893,17.488,0,14.726c7.553,10.305,23.975,6.092,26.42-3.832C28.254,10.908,29.332,10.259,30,9.542z"}})])]),_vm._v(" "),_c('a',{staticClass:"stalk-icon",attrs:{"href":"https://www.linkedin.com/company/hackdagio","target":"_blank"}},[_c('svg',{staticClass:"social-icon social-linked-in",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 18","enable-background":"new 0 0 20 18","xml:space":"preserve"}},[_c('g',[_c('rect',{attrs:{"x":"0.8","y":"6","width":"4","height":"12"}}),_vm._v(" "),_c('path',{attrs:{"d":"M2.8,4.4L2.8,4.4c-1.4,0-2.2-0.9-2.2-2.1c0-1.2,0.9-2.1,2.3-2.1c1.4,0,2.2,0.9,2.2,2.1\n                  C5.1,3.4,4.2,4.4,2.8,4.4z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M19.2,18h-4v-6.4c0-1.6-0.6-2.7-2-2.7c-1.1,0-1.8,0.7-2,1.5c-0.1,0.3-0.1,0.6-0.1,1V18H7C7,18,7.1,7.1,7,6\n                  h4v1.7c0.5-0.8,1.5-2,3.6-2c2.6,0,4.6,1.7,4.6,5.4V18z"}})])])]),_vm._v(" "),_c('a',{staticClass:"stalk-icon",attrs:{"href":"https://instagram.com/hackdagio/","title":"Instagram","target":"_blank"}},[_c('svg',{staticClass:"social-icon social-instagram",attrs:{"viewBox":"0 0 21 21","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('path',{attrs:{"d":"M18.5855434,9.35883181 L16.8479423,9.35883181 C16.9745691,9.85144265 17.0519522,10.3651654 17.0519522,10.9 C17.0519522,14.2990148 14.2943018,17.0576355 10.8964826,17.0576355 C7.49866338,17.0576355 4.74101301,14.2990148 4.74101301,10.9 C4.74101301,10.3651654 4.81839606,9.85144265 4.94502286,9.35883181 L3.20742174,9.35883181 L3.20742174,17.8247009 C3.20742174,18.2469388 3.55212803,18.5917664 3.97421738,18.5917664 L17.8187478,18.5917664 C18.2408371,18.5917664 18.5855434,18.2469388 18.5855434,17.8247009 L18.5855434,9.35883181 L18.5855434,9.35883181 L18.5855434,9.35883181 Z M18.5855434,3.97529909 C18.5855434,3.55306122 18.2408371,3.20823364 17.8187478,3.20823364 L15.5113261,3.20823364 C15.0892367,3.20823364 14.7445304,3.55306122 14.7445304,3.97529909 L14.7445304,6.28353272 C14.7445304,6.70577058 15.0892367,7.05059817 15.5113261,7.05059817 L17.8187478,7.05059817 C18.2408371,7.05059817 18.5855434,6.70577058 18.5855434,6.28353272 L18.5855434,3.97529909 L18.5855434,3.97529909 Z M10.8964826,7.05059817 C8.77196623,7.05059817 7.04843475,8.7747361 7.04843475,10.9 C7.04843475,13.0252639 8.77196623,14.7494018 10.8964826,14.7494018 C13.0209989,14.7494018 14.7445304,13.0252639 14.7445304,10.9 C14.7445304,8.7747361 13.0209989,7.05059817 10.8964826,7.05059817 L10.8964826,7.05059817 Z M18.5855434,20.9 L3.20742174,20.9 C1.93411889,20.9 0.9,19.8655172 0.9,18.5917664 L0.9,3.20823364 C0.9,1.93448276 1.93411889,0.9 3.20742174,0.9 L18.5925783,0.9 C19.8658811,0.9 20.9,1.93448276 20.9,3.20823364 L20.9,18.5988037 C20.8929652,19.8655172 19.8658811,20.9 18.5855434,20.9 L18.5855434,20.9 Z"}})])]),_vm._v(" "),_c('a',{staticClass:"stalk-icon",attrs:{"href":"https://github.com/hackdagio","title":"Github","target":"_blank"}},[_c('svg',{staticClass:"social-icon social-github",attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 30 22.9 ","xml:space":"preserve"}},[_c('path',{attrs:{"d":"M21.9,0c0.4,0.9,0.6,2.3,0.3,3.4c1.5,1.3,2.1,4.5,1.3,7.1c2.2,0.2,4.8-0.1,6.5,0.6c-1.6-0.2-3.7-0.6-5.8-0.5\n  c-0.4,0-1,0-0.9,0.5c2.4,0.2,4.7,0.4,6.6,1c-1.9-0.3-4.2-0.8-6.6-0.9c-1,1.9-3,2.9-5.7,3.1c0.3,0.6,0.9,0.9,1,1.9\n  c0.2,1.5-0.3,3.8,0.2,4.8c0.2,0.5,0.7,0.5,0.9,0.9c-0.7,0.8-2.3-0.1-2.5-0.9c-0.3-1.4,0.5-3.6-0.4-4.6c0.1,1.6-0.4,3.7,0.1,5.1\n  c0.2,0.5,0.7,0.8,0.5,1.2c-3.1,0.3-1.8-4-2.3-6.6c-0.5,0-0.3,0.7-0.3,1c0,2.5,0.5,5.9-2.2,5.6c-0.1-0.5,0.4-0.7,0.5-1.2\n  c0.5-1.4-0.1-3.5,0.1-5.2c-1,0.8,0.1,3.5-0.5,4.9c-0.4,0.8-1.6,1.1-2.5,0.8c0.1-0.6,0.7-0.5,1-1.1c0.4-0.8,0-1.9,0.1-3\n  C9.5,18.5,8,18,7.3,16.8c-0.3-0.5-0.4-1.2-0.8-1.6c-0.4-0.5-1-0.5-1.2-1.2c2.4-0.6,2.5,2.4,4.6,2.5c0.6,0,1-0.2,1.6-0.3\n  c0.2-0.8,0.5-1.3,1.1-1.7c-2.6-0.4-4.8-1.2-5.8-3.2c-2.4,0.1-4.6,0.4-6.6,0.9c1.8-0.7,4.1-0.9,6.6-1c-0.1-0.9-1.4-0.6-2.2-0.6\n  C3,10.7,1.2,10.9,0,11.1c1.7-0.6,4-0.5,6.3-0.5C5.6,8.4,5.9,5,7.4,3.7C6.9,2.6,7.1,0.8,7.6,0c1.7,0.1,2.7,0.8,3.8,1.5\n  c1.3-0.4,2.7-0.6,4.5-0.5c0.8,0,1.5,0.4,2.1,0.3c0.6-0.1,1.2-0.7,1.7-0.9C20.5,0.1,21.1,0,21.9,0L21.9,0z"}})])])])])])]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"legend-footer-label"},[_c('strong',{staticStyle:{"display":"none"}},[_vm._v("HACKDAGIO is ")]),_c('span',{staticStyle:{"text-transform":"uppercase"}},[_vm._v("a")]),_vm._v(" software company based in Santiago de Chile")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-footer-extras"},[_c('a',{attrs:{"href":"https://brew.engineering"}},[_c('span',{staticClass:"copyright-wrap"},[_vm._v("\n      © 2020\n      "),_c('span',{staticClass:"brew-copyright",attrs:{"itemscope":"","itemtype":"http://schema.org/Organization"}},[_c('span',{attrs:{"itemprop":"name"}},[_vm._v("Hackdagio")]),_vm._v(" "),_c('link',{attrs:{"itemprop":"url","href":"https://hackdagio.com/"}}),_vm._v(" "),_c('link',{attrs:{"itemprop":"sameAs","href":"https://twitter.com/hackdagio"}})]),_vm._v(" SpA\n        ")]),_c('br'),_c('small',[_vm._v("Los Abedules 3085, Vitacura, Chile")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "42Hy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("DK6z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf5737a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("VWBj");
function injectStyle (ssrContext) {
  __webpack_require__("w4tI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cf5737a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf5737a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4A3L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4PWc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4s5r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"how section",attrs:{"id":"how"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"heading col-12"},[_c('h3',[_vm._v("Apps, websites, enterprise software. "),_c('br'),_c('strong',{staticClass:"color-2"},[_vm._v("We do it all")])]),_vm._v(" "),_c('h4',{staticClass:"legend"},[_vm._v("We work with design conscious and fashion forward clients, from the very beginning – including, concept ideation, design execution, interactive prototypes, and everything in between. ")])]),_vm._v(" "),_c('div',{staticClass:"goals"},[_c('div',{staticClass:"goals__list"},[_c('section',{staticClass:"goals__item"},[_c('h6',{staticClass:"goals__item-heading"},[_c('span',{staticClass:"text sys-ops-fo"},[_vm._v("you")])]),_vm._v(" "),_c('ul',{staticClass:"goals__item-list"},[_c('li',{staticClass:"goals__item-goal"},[_vm._v("Budget")]),_vm._v(" "),_c('li',{staticClass:"goals__item-goal"},[_vm._v("Backlog")]),_vm._v(" "),_c('li',{staticClass:"goals__item-goal"},[_vm._v("Test - Fast failing")]),_vm._v(" "),_c('li',{staticClass:"goals__item-goal"},[_vm._v("Domain knowledge")]),_vm._v(" "),_c('li',{staticClass:"goals__item-goal"},[_vm._v("Business knowledge")])])]),_vm._v(" "),_c('section',{staticClass:"goals__item"},[_c('h6',{staticClass:"goals__item-heading"},[_c('span',{staticClass:"text sys-ops-fo"},[_vm._v("the product")])])]),_vm._v(" "),_c('section',{staticClass:"goals__item"},[_c('h6',{staticClass:"goals__item-heading "},[_c('span',{staticClass:"text sys-ops-fo"},[_vm._v("us")])]),_vm._v(" "),_c('ul',{staticClass:"goals__item-list"},[_c('li',{staticClass:"goals__item-goal"},[_vm._v("Design")]),_vm._v(" "),_c('li',{staticClass:"goals__item-goal"},[_vm._v("Software architecture")]),_vm._v(" "),_c('li',{staticClass:"goals__item-goal"},[_vm._v("QA")]),_vm._v(" "),_c('li',{staticClass:"goals__item-goal"},[_vm._v("Automation")]),_vm._v(" "),_c('li',{staticClass:"goals__item-goal"},[_vm._v("App development")])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AcTI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DK6z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Index',
  data: function data() {
    return {
      msg: ''
    };
  }
});

/***/ }),

/***/ "DpAH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Hero',
  data: function data() {
    return {
      title: 'Delightful, consumer-grade experiences',
      from: 'desde Colchagua',
      legend: 'Brew es un colectivo de profesionales tecnólogos, consultores, diseñadores y desarrolladores de software, dedicados al servicio de consultoría en tecnologías de la información y desarrollo.'
    };
  }
});

/***/ }),

/***/ "FAPV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"why section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"heading col-12"},[_c('h3',[_vm._v("You + us = "),_c('strong',{staticClass:"color-2"},[_vm._v("win win")])]),_vm._v(" "),_c('h4',{staticClass:"legend"},[_vm._v("We search the best ways to create software - by combining industry-leading technologies and choosing the correct agile methodology. ")])])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"ill-technology"},[_c('ul',{staticClass:"ill-technology-list"},[_c('li',{staticClass:"ill-technology-item pos1"},[_vm._v("Domain knowledge")]),_vm._v(" "),_c('li',{staticClass:"ill-technology-item pos2"},[_vm._v("Business")]),_vm._v(" "),_c('li',{staticClass:"ill-technology-item pos3"},[_vm._v("Services")]),_vm._v(" "),_c('li',{staticClass:"ill-technology-item pos4"},[_vm._v("Our Expertise")])]),_vm._v(" "),_c('div',{staticClass:"ill-technology-cirlce"},[_c('div',{staticClass:"ill-technology-cirlce_main"}),_vm._v(" "),_c('div',{staticClass:"ill-technology-cirlce_small pos1"}),_vm._v(" "),_c('div',{staticClass:"ill-technology-cirlce_small pos2"}),_vm._v(" "),_c('div',{staticClass:"ill-technology-cirlce_large pos1"}),_vm._v(" "),_c('div',{staticClass:"ill-technology-cirlce_large pos2"}),_vm._v(" "),_c('div',{staticClass:"ill-technology-cirlce_large pos3"}),_vm._v(" "),_c('div',{staticClass:"ill-technology-cirlce_large pos4"})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FnhZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__("/oiM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73c6a204_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__("gCOu");
function injectStyle (ssrContext) {
  __webpack_require__("PKbr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73c6a204"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73c6a204_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ft9h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Why',
  data: function data() {
    return {
      msg: ''
    };
  }
});

/***/ }),

/***/ "FtYk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_What_vue__ = __webpack_require__("KRBg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_990c6e54_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_What_vue__ = __webpack_require__("z/lm");
function injectStyle (ssrContext) {
  __webpack_require__("nTSM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-990c6e54"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_What_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_990c6e54_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_What_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HB62":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Clients',
  data: function data() {
    return {
      msg: ''
    };
  }
});

/***/ }),

/***/ "HCTz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Header',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),

/***/ "HUt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__ = __webpack_require__("fcFS");
function injectStyle (ssrContext) {
  __webpack_require__("4PWc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I30t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero-area"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"hero-tile-container col-12 col-sm-12 col-md-7 col-lg-7 col-xl-6"},[_c('h3',{staticClass:"hero-splash gradient-special-color"},[_vm._v(_vm._s(_vm.title)),_c('br')]),_vm._v(" "),_c('a',{staticClass:"btn btn-main",attrs:{"href":"mailto:hey@hackdagio.xyz","role":"button"}},[_c('svg',{staticClass:"send-email-att btn-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 480 320"}},[_c('circle',{attrs:{"cx":"416","cy":"64","r":"64"}}),_c('path',{attrs:{"d":"M209 64H17.8C6.7 64 3.9 67 6.5 74.5 8 78.9 14.9 82.6 19 84.7c11 5.8 163.8 89.1 169.5 92.1 5.7 3 11.5 4.4 20.5 4.4s14.8-1.4 20.5-4.4c3.8-2 72.6-39.5 121.6-66.1C341.6 97.6 336 81.4 336 64H209z"}}),_c('path',{attrs:{"d":"M277.2 177.3l82.2 92.5c2 2 2.9 4.4 1.8 5.6-1.2 1.1-3.8.5-5.9-1.4l-98.6-83.2c-14.9 9.6-25.4 16.2-27.2 17.2-7.7 3.9-13.1 4.4-20.5 4.4s-12.8-.5-20.5-4.4c-1.9-1-12.3-7.6-27.2-17.2L62.7 274c-2 2-4.7 2.6-5.9 1.4-1.2-1.1-.3-3.6 1.7-5.6l82.1-92.5C91.9 145.8 17.5 93.4 9.3 89.2.5 84.7 0 90 0 94.1v205c0 9.3 13.7 20.9 23.5 20.9h371c9.8 0 21.5-11.7 21.5-20.9V144c-21.7 0-41.4-8.7-55.8-22.7-26 17.9-57.8 39.7-83 56z"}}),_c('path',{attrs:{"d":"M417.7 10.7c12.1 0 23.3 4 32.3 10.6-18.4 23.9-61 43.8-81.2 67.9-3.6-7.3-5.6-15.4-5.6-24 0-30 24.5-54.5 54.5-54.5z"}})]),_vm._v("\n                Let's talk")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero-image-container col-12 col-sm-12 col-md-5 col-lg-5 col-xl-6 text-center"},[_c('img',{staticClass:"static-proto",attrs:{"src":"static/proto.svg","alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JCpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__("aPSQ");
function injectStyle (ssrContext) {
  __webpack_require__("OS02")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JDVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__ = __webpack_require__("kJiG");
function injectStyle (ssrContext) {
  __webpack_require__("e+5f")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KRBg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'What',
  data: function data() {
    return {
      msg: ''
    };
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a80d81a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("V6uE");
function injectStyle (ssrContext) {
  __webpack_require__("ttew")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a80d81a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MO4T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mrsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Clients_vue__ = __webpack_require__("HB62");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b444634_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Clients_vue__ = __webpack_require__("bLL+");
function injectStyle (ssrContext) {
  __webpack_require__("RCmW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8b444634"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Clients_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b444634_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Clients_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "OS02":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PKbr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PtIi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Default',
  data: function data() {
    return {
      msg: ''
    };
  }
});

/***/ }),

/***/ "Q6U1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RCmW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sdpc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TVmP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("UthT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c607cca6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("3tuG");
function injectStyle (ssrContext) {
  __webpack_require__("WiMi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c607cca6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c607cca6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UfZ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hero_vue__ = __webpack_require__("DpAH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b51630c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hero_vue__ = __webpack_require__("I30t");
function injectStyle (ssrContext) {
  __webpack_require__("2vPH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b51630c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hero_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b51630c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hero_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UthT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Footer',
  data: function data() {
    return {
      msg: ''
    };
  }
});

/***/ }),

/***/ "V6qR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V6uE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{staticClass:"default"}),_vm._v(" "),_c('router-view',{staticClass:"header",attrs:{"name":"header"}}),_vm._v(" "),_c('router-view',{attrs:{"name":"hero"}}),_vm._v(" "),_c('router-view',{staticClass:"container-fluid",attrs:{"name":"what"}}),_vm._v(" "),_c('router-view',{staticClass:"container-fluid",attrs:{"name":"why"}}),_vm._v(" "),_c('router-view',{staticClass:"container-fluid",attrs:{"name":"clients"}}),_vm._v(" "),_c('router-view',{staticClass:"container-fluid",attrs:{"name":"how"}}),_vm._v(" "),_c('router-view',{staticClass:"container-fluid",attrs:{"name":"contact"}}),_vm._v(" "),_c('router-view',{staticClass:"container-fluid",attrs:{"name":"footer"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VWBj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section index",attrs:{"id":"index"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section__heading",staticStyle:{"opacity":"1","transform":"matrix(1, 0, 0, 1, 0, 0)"}},[_c('h2',{staticClass:"section__title"},[_vm._v("Technology index")]),_vm._v(" "),_c('p',{staticClass:"section__intro"},[_vm._v("We use modern, proven technologies and approaches that let us build performant and easily scalable digital products for mobile, web, wearables, TV, and IoT.")])]),_vm._v(" "),_c('ul',{staticClass:"list list--icons list--platforms"},[_c('li',{staticClass:"list__item",staticStyle:{"opacity":"1","transform":"matrix(1, 0, 0, 1, 0, 0)"}},[_c('div',{staticClass:"img-wrap"},[_c('img',{staticClass:"img",staticStyle:{"transform":"matrix(1, 0, 0, 1, 0, 0)"},attrs:{"src":"https://yalantis.com/assets/v3/icons/platforms/icon-web-9a56946bcabfe4005c769d21a1d4ef799042171ef1380daf534ffb4dc8b00a3c.svg","alt":""}})]),_c('span',{staticClass:"title"},[_vm._v("Web")])]),_vm._v(" "),_c('li',{staticClass:"list__item",staticStyle:{"opacity":"1","transform":"matrix(1, 0, 0, 1, 0, 0)"}},[_c('div',{staticClass:"img-wrap"},[_c('img',{staticClass:"img",staticStyle:{"transform":"matrix(1, 0, 0, 1, 0, 0)"},attrs:{"src":"https://yalantis.com/assets/v3/icons/platforms/icon-ios-179930f103fe093c779cfc6ac8fac33e3101175c5c81763cc8269f7fa9e5998e.svg","alt":""}})]),_c('span',{staticClass:"title"},[_vm._v("iOS")])]),_vm._v(" "),_c('li',{staticClass:"list__item",staticStyle:{"opacity":"1","transform":"matrix(1, 0, 0, 1, 0, 0)"}},[_c('div',{staticClass:"img-wrap"},[_c('img',{staticClass:"img",staticStyle:{"transform":"matrix(1, 0, 0, 1, 0, 0)"},attrs:{"src":"https://yalantis.com/assets/v3/icons/platforms/icon-android-65850262d7186ca4c0ac675cff6e8371085efe81bdb4d532565b35ab53c3760b.svg","alt":""}})]),_c('span',{staticClass:"title"},[_vm._v("Android")])]),_vm._v(" "),_c('li',{staticClass:"list__item",staticStyle:{"opacity":"1","transform":"matrix(1, 0, 0, 1, 0, 0)"}},[_c('div',{staticClass:"img-wrap"},[_c('img',{staticClass:"img",staticStyle:{"transform":"matrix(1, 0, 0, 1, 0, 0)"},attrs:{"src":"https://yalantis.com/assets/v3/icons/platforms/icon-wearables-f09d454da45868798bba06c6102f7b3d7f7a52b62cbafc9994c43f7427a882d2.svg","alt":""}})]),_c('span',{staticClass:"title"},[_vm._v("Wearables")])]),_vm._v(" "),_c('li',{staticClass:"list__item",staticStyle:{"opacity":"1","transform":"matrix(1, 0, 0, 1, 0, 0)"}},[_c('div',{staticClass:"img-wrap"},[_c('img',{staticClass:"img",staticStyle:{"transform":"matrix(1, 0, 0, 1, 0, 0)"},attrs:{"src":"https://yalantis.com/assets/v3/icons/platforms/icon-tv-159b4893a36bfdd70cfd348ef4024491ba9e02af6263c75e629f91d72c227af2.svg","alt":""}})]),_c('span',{staticClass:"title"},[_vm._v("TV")])]),_vm._v(" "),_c('li',{staticClass:"list__item",staticStyle:{"opacity":"1","transform":"matrix(1, 0, 0, 1, 0, 0)"}},[_c('div',{staticClass:"img-wrap"},[_c('img',{staticClass:"img",staticStyle:{"transform":"matrix(1, 0, 0, 1, 0, 0)"},attrs:{"src":"https://yalantis.com/assets/v3/icons/platforms/icon-iot-8b529a6f18e5eae0e00309da788d62a81a92edc50cdcf1d807af87400e50b14b.svg","alt":""}})]),_c('span',{staticClass:"title"},[_vm._v("IoT")])])]),_vm._v(" "),_c('div',{staticClass:"section__control",staticStyle:{"opacity":"1","transform":"matrix(1, 0, 0, 1, 0, 0)"}},[_c('a',{staticClass:"btn btn--bordered btn--arrow",attrs:{"href":"/technologies/","rel":"nofollow"}},[_vm._v("See our tech stack")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WiMi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YDcY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"feature section",attrs:{"id":"feature"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"heading col-12"},[_c('h3',[_vm._v("Big things are "),_c('strong',{staticClass:"color-2"},[_vm._v("happening")])]),_vm._v(" "),_c('h4',{staticClass:"legend"},[_vm._v("When we build strong relationships with our partners, step by step: being responsible with the projects, making our processes very transparent and offering excellent results.")])]),_vm._v(" "),_c('div',{staticClass:"work__w col-12"},[_c('div',{staticClass:"work-block col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('h4',{staticClass:"title",staticStyle:{"-webkit-backface-visibility":"visible","z-index":"0","opacity":"1","transform":"matrix(1, 0, 0, 1, 0, 0)"}},[_vm._v("We do apps")]),_vm._v(" "),_c('div',{staticClass:"line__w"},[_c('div',{staticClass:"line",staticStyle:{"width":"140px"}})]),_vm._v(" "),_c('div',{staticClass:"text",staticStyle:{"-webkit-backface-visibility":"visible","opacity":"0.800000011920929","transform":"matrix(1, 0, 0, 1, 0, 0)"}},[_vm._v("We have the required experience that our partners need in order to build an outstanding product at sight.")])]),_vm._v(" "),_c('div',{staticClass:"work-block col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('h4',{staticClass:"title",staticStyle:{"-webkit-backface-visibility":"visible","z-index":"0","opacity":"1","transform":"matrix(1, 0, 0, 1, 0, 0)"}},[_vm._v("We do agile")]),_vm._v(" "),_c('div',{staticClass:"line__w"},[_c('div',{staticClass:"line",staticStyle:{"width":"140px"}})]),_vm._v(" "),_c('div',{staticClass:"text",staticStyle:{"-webkit-backface-visibility":"visible","opacity":"0.800000011920929","transform":"matrix(1, 0, 0, 1, 0, 0)"}},[_vm._v("We intensify our knowledge, improve our internal processes, clutter out our inefficiency and build the best possible product.")])]),_vm._v(" "),_c('div',{staticClass:"work-block col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('h4',{staticClass:"title",staticStyle:{"-webkit-backface-visibility":"visible","z-index":"0","opacity":"1","transform":"matrix(1, 0, 0, 1, 0, 0)"}},[_vm._v("We design")]),_vm._v(" "),_c('div',{staticClass:"line__w"},[_c('div',{staticClass:"line",staticStyle:{"width":"140px"}})]),_vm._v(" "),_c('div',{staticClass:"text",staticStyle:{"-webkit-backface-visibility":"visible","opacity":"0.800000011920929","transform":"matrix(1, 0, 0, 1, 0, 0)"}},[_vm._v("From drawing in plain paper to adding UI animations and interactions, we design prototypes from the ground up. You being part of it in every step.")])]),_vm._v(" "),_c('div',{staticClass:"work-block col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('h4',{staticClass:"title",staticStyle:{"-webkit-backface-visibility":"visible","z-index":"0","opacity":"1","transform":"matrix(1, 0, 0, 1, 0, 0)"}},[_vm._v("We focus on you")]),_vm._v(" "),_c('div',{staticClass:"line__w"},[_c('div',{staticClass:"line",staticStyle:{"width":"140px"}})]),_vm._v(" "),_c('div',{staticClass:"text",staticStyle:{"-webkit-backface-visibility":"visible","opacity":"0.800000011920929","transform":"matrix(1, 0, 0, 1, 0, 0)"}},[_vm._v("We get involved with your needs, featuring fully dedicated development teams. From the very beginning of the project, you have total control.")])]),_vm._v(" "),_c('div',{staticClass:"work-block col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('h4',{staticClass:"title",staticStyle:{"-webkit-backface-visibility":"visible","z-index":"0","opacity":"1","transform":"matrix(1, 0, 0, 1, 0, 0)"}},[_vm._v("Continuous integration")]),_vm._v(" "),_c('div',{staticClass:"line__w"},[_c('div',{staticClass:"line",staticStyle:{"width":"140px"}})]),_vm._v(" "),_c('div',{staticClass:"text",staticStyle:{"-webkit-backface-visibility":"visible","opacity":"0.800000011920929","transform":"matrix(1, 0, 0, 1, 0, 0)"}},[_vm._v("Every commit that we finish could perfectly end up in a release pipeline. Our software development techniques reduces risks. ")])]),_vm._v(" "),_c('div',{staticClass:"work-block col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('h4',{staticClass:"title",staticStyle:{"-webkit-backface-visibility":"visible","z-index":"0","opacity":"1","transform":"matrix(1, 0, 0, 1, 0, 0)"}},[_vm._v("Our mojo")]),_vm._v(" "),_c('div',{staticClass:"line__w"},[_c('div',{staticClass:"line",staticStyle:{"width":"140px"}})]),_vm._v(" "),_c('div',{staticClass:"text",staticStyle:{"-webkit-backface-visibility":"visible","opacity":"0.800000011920929","transform":"matrix(1, 0, 0, 1, 0, 0)"}},[_vm._v("We keep things clear and simple. We follow the best industry practices in order to maintain our products easy to scale over time.")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Default__ = __webpack_require__("xz+F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Hero__ = __webpack_require__("UfZ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Features__ = __webpack_require__("uaBb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_How__ = __webpack_require__("y/lb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Why__ = __webpack_require__("340w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Clients__ = __webpack_require__("Mrsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Contact__ = __webpack_require__("FnhZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Footer__ = __webpack_require__("TVmP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bootstrap_vue__ = __webpack_require__("e6fC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_What__ = __webpack_require__("FtYk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Index__ = __webpack_require__("42Hy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_bootstrap_dist_css_bootstrap_css__);


















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_bootstrap_vue__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/contacto',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_2__components_Default__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_3__components_Header__["a" /* default */],
      contact: __WEBPACK_IMPORTED_MODULE_9__components_Contact__["a" /* default */],
      footer: __WEBPACK_IMPORTED_MODULE_10__components_Footer__["a" /* default */]
    }
  }, {
    path: '*',
    name: 'Hello',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_2__components_Default__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_3__components_Header__["a" /* default */],
      hero: __WEBPACK_IMPORTED_MODULE_4__components_Hero__["a" /* default */],
      features: __WEBPACK_IMPORTED_MODULE_5__components_Features__["a" /* default */],
      how: __WEBPACK_IMPORTED_MODULE_6__components_How__["a" /* default */],
      why: __WEBPACK_IMPORTED_MODULE_7__components_Why__["a" /* default */],
      contact: __WEBPACK_IMPORTED_MODULE_9__components_Contact__["a" /* default */],
      clients: __WEBPACK_IMPORTED_MODULE_8__components_Clients__["a" /* default */],
      footer: __WEBPACK_IMPORTED_MODULE_10__components_Footer__["a" /* default */],
      what: __WEBPACK_IMPORTED_MODULE_12__components_What__["a" /* default */],
      index: __WEBPACK_IMPORTED_MODULE_13__components_Index__["a" /* default */]
    }
  }]
}));

/***/ }),

/***/ "a1eq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'How',
  data: function data() {
    return {
      msg: ''
    };
  }
});

/***/ }),

/***/ "aPSQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__("rKsW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__modal__["a" /* default */]);

/***/ }),

/***/ "bLL+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"clientele section",attrs:{"id":"clients"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"heading col-12"},[_c('h3',{staticClass:"title"},[_vm._v("Our amazing clients")]),_vm._v(" "),_c('h4',{staticClass:"legend"},[_vm._v("From SaaS and corporate software, to mobile apps and websites, we build digital experiences that our clients love.")]),_vm._v(" "),_c('h4',{staticClass:"legend"},[_vm._v("We work as one team with them in an iterative design and development process.")])])])]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"client-logo-band"},[_c('div',{staticClass:"client-logo-wrap"},[_c('img',{staticClass:"client-logo-image",staticStyle:{"transform":"scale(0.7)"},attrs:{"alt":"Casino Colchagua","src":"/static/img/clients-logos/casino-colchagua.svg"}})]),_vm._v(" "),_c('div',{staticClass:"client-logo-wrap"},[_c('img',{staticClass:"client-logo-image",attrs:{"alt":"Alma Cruz","src":"/static/img/clients-logos/almacruz.svg"}})]),_vm._v(" "),_c('div',{staticClass:"client-logo-wrap"},[_c('img',{staticClass:"client-logo-image",attrs:{"alt":"Hotel Santa Cruz","src":"/static/img/clients-logos/hotel-santa-cruz.svg"}})]),_vm._v(" "),_c('div',{staticClass:"client-logo-wrap"},[_c('img',{staticClass:"client-logo-image",attrs:{"alt":"Viña Santa Cruz","src":"/static/img/clients-logos/vina-santa-cruz.svg"}})]),_vm._v(" "),_c('div',{staticClass:"client-logo-wrap"},[_c('img',{staticClass:"client-logo-image",attrs:{"alt":"Museo de Colchagua","src":"/static/img/clients-logos/museo-colchagua.svg"}})]),_vm._v(" "),_c('div',{staticClass:"client-logo-wrap"},[_c('img',{staticClass:"client-logo-image",attrs:{"alt":"Viña Montes","src":"/static/img/clients-logos/montes-wines.svg"}})]),_vm._v(" "),_c('div',{staticClass:"client-logo-wrap"},[_c('img',{staticClass:"client-logo-image",attrs:{"alt":"Banco Security","src":"/static/img/clients-logos/banco-security.svg"}})]),_vm._v(" "),_c('div',{staticClass:"client-logo-wrap"},[_c('img',{staticClass:"client-logo-image",attrs:{"alt":"SP Digital.cl","src":"/static/img/clients-logos/sp-digital.svg"}})]),_vm._v(" "),_c('div',{staticClass:"client-logo-wrap"},[_c('img',{staticClass:"client-logo-image",attrs:{"alt":"Ripley","src":"/static/img/clients-logos/ripley.svg"}})]),_vm._v(" "),_c('div',{staticClass:"client-logo-wrap"},[_c('img',{staticClass:"client-logo-image",staticStyle:{"transform":"scale(0.5)"},attrs:{"alt":"Canal 13","src":"/static/img/clients-logos/canal-13.svg"}})]),_vm._v(" "),_c('div',{staticClass:"client-logo-wrap"},[_c('img',{staticClass:"client-logo-image",attrs:{"alt":"Dunkin' Donuts","src":"/static/img/clients-logos/dunkin-donuts.svg"}})]),_vm._v(" "),_c('div',{staticClass:"client-logo-wrap"},[_c('img',{staticClass:"client-logo-image",attrs:{"alt":"BCP","src":"/static/img/clients-logos/bcp.svg"}})]),_vm._v(" "),_c('div',{staticClass:"client-logo-wrap"},[_c('img',{staticClass:"client-logo-image",attrs:{"alt":"Universidad Diego Portales","src":"/static/img/clients-logos/udp.svg"}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e+5f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fcFS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_input__ = __webpack_require__("qRo1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_input__["a" /* default */]);

/***/ }),

/***/ "gCOu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"contact section",attrs:{"id":"contact"}},[_c('div',{staticClass:"container contact-block"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 content-header"},[_c('h6',{staticClass:"page-title stage-one"},[_vm._v("Let's talk")]),_vm._v(" "),_c('span',{staticClass:"red-line hidden-sm-down"}),_vm._v(" "),_c('a',{staticClass:"stage-two sys-ops-fo",attrs:{"href":"mailto:hey@hackdagio.xyz"}},[_vm._v("hey@hackdagio.xyz")]),_vm._v(" "),_c('br')])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jPPl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kJiG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_file__ = __webpack_require__("9NuQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_file__["a" /* default */]);

/***/ }),

/***/ "nTSM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r15W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__("xKc6");
function injectStyle (ssrContext) {
  __webpack_require__("Sdpc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "teIl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("HCTz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83a304c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("17MB");
function injectStyle (ssrContext) {
  __webpack_require__("MO4T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-83a304c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83a304c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ttew":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uBp7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Features',
  data: function data() {
    return {
      msg: ''
    };
  }
});

/***/ }),

/***/ "uaBb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Features_vue__ = __webpack_require__("uBp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05e75e62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Features_vue__ = __webpack_require__("YDcY");
function injectStyle (ssrContext) {
  __webpack_require__("jPPl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05e75e62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Features_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05e75e62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Features_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w4tI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "xKc6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress__ = __webpack_require__("E9Zr");
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__progress__["a" /* default */]);

/***/ }),

/***/ "xz+F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Default_vue__ = __webpack_require__("PtIi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acbd2ec2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Default_vue__ = __webpack_require__("0w6L");
function injectStyle (ssrContext) {
  __webpack_require__("4A3L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-acbd2ec2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Default_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acbd2ec2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Default_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y/lb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_How_vue__ = __webpack_require__("a1eq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c6e9a2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_How_vue__ = __webpack_require__("4s5r");
function injectStyle (ssrContext) {
  __webpack_require__("Q6U1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c6e9a2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_How_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c6e9a2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_How_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z/lm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"what section",attrs:{"id":"what"}},[_c('ul',{staticClass:"list list--services-blocks"},[_c('li',{staticClass:"list__item"},[_c('div',{staticClass:"list__item-inner"},[_c('div',{staticClass:"img-wrap",staticStyle:{"background-image":"url('static/img/what/ios-dev-hero.jpg')"}}),_vm._v(" "),_c('div',{staticClass:"list__item-content"},[_c('h3',{staticClass:"title"},[_vm._v("iOS "),_c('br'),_vm._v("Development")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("We use modern programming languages, such as Swift and Objective-C, and proven technologies and approaches that allow us to easily extend and scale our products.")])])])]),_vm._v(" "),_c('li',{staticClass:"list__item"},[_c('div',{staticClass:"list__item-inner"},[_c('div',{staticClass:"img-wrap",staticStyle:{"background-image":"url('static/img/what/android-dev-hero.jpg')"}}),_vm._v(" "),_c('div',{staticClass:"list__item-content"},[_c('h3',{staticClass:"title"},[_vm._v("Android "),_c('br'),_vm._v("Development")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("We develop Android apps in Java and Kotlin. Given the broad range of devices capable of running Android, we can create apps for everything from smartwatches to smart TVs.")])])])]),_vm._v(" "),_c('li',{staticClass:"list__item"},[_c('div',{staticClass:"list__item-inner"},[_c('div',{staticClass:"img-wrap",staticStyle:{"background-image":"url('static/img/what/ux-ui-st-hero.jpg')"}}),_vm._v(" "),_c('div',{staticClass:"list__item-content"},[_c('h3',{staticClass:"title"},[_vm._v("UI/UX "),_c('br'),_vm._v("Design")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("We offer prototyping, branding, UI and UX design for web and mobile products. Our approach is simple: we focus on how actual people will use our clients’ products.")])])])]),_vm._v(" "),_c('li',{staticClass:"list__item"},[_c('div',{staticClass:"list__item-inner"},[_c('div',{staticClass:"img-wrap",staticStyle:{"background-image":"url('static/img/what/web-dev-hero.jpg')"}}),_vm._v(" "),_c('div',{staticClass:"list__item-content"},[_c('h3',{staticClass:"title"},[_vm._v("Web "),_c('br'),_vm._v("Development")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("We provide both frontend and backend development services. Our web development team specializes in Ruby on Rails, Go, JavaScript, AngularJS, React, Node.js, and Elixir.")])])])]),_vm._v(" "),_c('li',{staticClass:"list__item"},[_c('div',{staticClass:"list__item-inner"},[_c('div',{staticClass:"img-wrap",staticStyle:{"background-image":"url('static/img/what/pm-st-hero.jpg')"}}),_vm._v(" "),_c('div',{staticClass:"list__item-content"},[_c('h3',{staticClass:"title"},[_vm._v("Project "),_c('br'),_vm._v("Management")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("Our dedicated project managers ensure that all your expectations and requirements are met, supervise your team’s performance, and make sure that your product is delivered on schedule.")])])])]),_vm._v(" "),_c('li',{staticClass:"list__item"},[_c('div',{staticClass:"list__item-inner"},[_c('div',{staticClass:"img-wrap",staticStyle:{"background-image":"url('static/img/what/qa-st-hero.jpg')"}}),_vm._v(" "),_c('div',{staticClass:"list__item-content"},[_c('h3',{staticClass:"title"},[_vm._v("Quality "),_c('br'),_vm._v("Assurance")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("Our quality control team verifies that developed functionality meets business objectives and ensures that code is relatively bug-free by applying manual and automated testing.")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.3d9a644185dc4f43937b.js